/* import __COLOCATED_TEMPLATE__ from './localization-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();